import Vue from 'vue';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import './assets/css/style.css';
import "./assets/scss/app.scss";
import VueGtag from "vue-gtag";

/* eslint-disable */
// import firebase from './firebase';
import auth from './auth';
/* eslint-enable */
import App from './App.vue';
import router from './router';
import store from './store/index';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import InstantSearch from 'vue-instantsearch';
import VueObserveVisibility from 'vue-observe-visibility';

//temp timer
import VueCountdownTimer from 'vuejs-countdown-timer'
import VueCarousel from 'vue-carousel';


Vue.use(VueCountdownTimer)
Vue.use(VueCarousel);

Vue.use(
  VueGtag,
  {
    config: { id: "UA-157119127-1" }
  },
  router
);



library.add(fas);
Vue.component('vue-fontawesome', FontAwesomeIcon);

Vue.use(require('vue-moment'));
Vue.use(InstantSearch);
Vue.use(VueObserveVisibility);

Vue.config.productionTip = false;
 
Vue.use(Buefy, {
  defaultIconComponent: 'vue-fontawesome',
  defaultIconPack: 'fas',
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');